<template>
    <secondLevelDetailsConfig :showConfigPopup="true"></secondLevelDetailsConfig>
</template>

<script>

import secondLevelDetailsConfig from "../widgets/SecondLevelDetailsConfig";

export default {
  name: "dashboardSecondLevelDetails",
  components: {
      secondLevelDetailsConfig
  },
  data() {
    return {

    }
  },
}
</script>

<style scoped>

</style>